export default "__VITE_ASSET__2f5468d4__"